import { useEffect } from "react";
import { useProjectStore } from "../stores/projectStore";
import { getProjects } from "../services/api-server/projects";
import { TProjectData } from "../types/project";

const getProjectIdFromPath = (pathname: string): string | null => {
	const match = pathname.match(/^\/projects\/([^/]+)/);
	return match ? match[1] : null;
};

function useInitProject(currentTenantKey: string | null) {
	const { project, setProject } = useProjectStore();
	const projectId = getProjectIdFromPath(location.pathname);

	useEffect(() => {
		if (!currentTenantKey) return;
		if (!projectId) {
			setProject({} as TProjectData);
			return;
		}
		if (!project || project._id !== projectId) {
			getProjects(currentTenantKey, {
				project_code: projectId,
			}).then((project: any) => {
				setProject(project[0]);
			});
		}
	}, [projectId, currentTenantKey]);
}

export default useInitProject;
